import type { JSX } from 'react';

import type { StarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { PostPreview } from 'src/app/pages/starterDashboardV2/shared/components';

import type { SharingPostData } from '../../../../hooks/useSharingTools';

export function ReadyToSharePostsCardPreview({
	facebookPost,
	instagramStory,
	isLoading,
	petition,
	onFacebookPostClick,
	onInstagramStoryClick,
}: {
	facebookPost: SharingPostData;
	instagramStory: SharingPostData;
	isLoading: boolean;
	petition: StarterDashboardV2PageData['petition'];
	onFacebookPostClick: () => void;
	onInstagramStoryClick: () => void;
}): JSX.Element | null {
	return (
		<div className="flex w-full flex-row justify-evenly">
			<PostPreview
				data-testid="facebook-post-preview"
				data-qa="facebook-post-preview"
				variant={facebookPost.fullPostType}
				petition={petition}
				disabled={false}
				sharingResource={facebookPost.sharingResource}
				size="xsmall"
				loading={isLoading}
				showPlatformIcon
				onClick={onFacebookPostClick}
			/>
			<PostPreview
				data-testid="instagram-story-preview"
				data-qa="instagram-story-preview"
				variant={instagramStory.fullPostType}
				petition={petition}
				disabled={false}
				sharingResource={instagramStory.sharingResource}
				size="xsmall"
				loading={isLoading}
				showPlatformIcon
				onClick={onInstagramStoryClick}
			/>
		</div>
	);
}
